/**
 * 测试环境快速填充工具
 * 用于开发测试时快速生成答案
 * 支持霍兰德职业兴趣测试(90题二元选择)
 */

/**
 * 根据霍兰德类型生成匹配的答案
 * @param {string} hollandType - 霍兰德类型代码 ('R', 'I', 'A', 'S', 'E', 'C')
 * @returns {Array} 答案数组 [0, 1, 1, ..., 0] 长度90 (0=不喜欢, 1=喜欢)
 */
export function generateAnswersForHollandType(hollandType) {
  // 预设的霍兰德类型对应的维度倾向 (概率)
  const hollandProfiles = {
    'R': {
      R: 0.85,  // 实际型倾向高
      I: 0.45,
      A: 0.30,
      S: 0.35,
      E: 0.40,
      C: 0.50
    },
    'I': {
      R: 0.45,
      I: 0.85,  // 研究型倾向高
      A: 0.50,
      S: 0.40,
      E: 0.35,
      C: 0.45
    },
    'A': {
      R: 0.30,
      I: 0.50,
      A: 0.85,  // 艺术型倾向高
      S: 0.55,
      E: 0.45,
      C: 0.25
    },
    'S': {
      R: 0.35,
      I: 0.40,
      A: 0.55,
      S: 0.85,  // 社会型倾向高
      E: 0.50,
      C: 0.40
    },
    'E': {
      R: 0.40,
      I: 0.35,
      A: 0.45,
      S: 0.50,
      E: 0.85,  // 企业型倾向高
      C: 0.55
    },
    'C': {
      R: 0.50,
      I: 0.45,
      A: 0.25,
      S: 0.40,
      E: 0.55,
      C: 0.85   // 传统型倾向高
    }
  }

  const profile = hollandProfiles[hollandType]
  if (!profile) {
    throw new Error(`未找到霍兰德类型: ${hollandType}`)
  }

  const answers = []
  
  // 6个维度,每个维度15题,共90题
  const dimensions = ['R', 'I', 'A', 'S', 'E', 'C']

  dimensions.forEach(dimension => {
    const probability = profile[dimension]
    // 每个维度15题
    for (let i = 0; i < 15; i++) {
      // 根据概率生成0或1
      const answer = Math.random() < probability ? 1 : 0
      answers.push(answer)
    }
  })

  return answers
}

/**
 * 快速填充所有答案为指定选择
 * @param {number} choice - 选择 (0=不喜欢, 1=喜欢)
 * @returns {Array} 答案数组
 */
export function generateAnswersForChoice(choice) {
  if (choice !== 0 && choice !== 1) {
    throw new Error(`无效的选择: ${choice}`)
  }
  
  const answers = []
  for (let i = 0; i < 90; i++) {
    answers.push(choice)
  }
  
  return answers
}

/**
 * 生成随机答案(霍兰德测试)
 * @returns {Array} 答案数组
 */
export function generateRandomAnswers() {
  const answers = []
  for (let i = 0; i < 90; i++) {
    answers.push(Math.random() > 0.5 ? 1 : 0) // 随机0或1
  }
  return answers
}

/**
 * 获取所有霍兰德类型列表
 * @returns {Array} 霍兰德类型列表
 */
export function getAllHollandTypes() {
  return [
    { code: 'R', name: '实际型', emoji: '🔧', description: '喜欢动手操作和实际工作' },
    { code: 'I', name: '研究型', emoji: '🔬', description: '喜欢研究探索和分析问题' },
    { code: 'A', name: '艺术型', emoji: '🎨', description: '喜欢艺术创作和自由表达' },
    { code: 'S', name: '社会型', emoji: '🤝', description: '喜欢帮助他人和团队合作' },
    { code: 'E', name: '企业型', emoji: '💼', description: '喜欢领导管理和追求成就' },
    { code: 'C', name: '传统型', emoji: '📊', description: '喜欢规律结构和精确工作' }
  ]
}

/**
 * 获取霍兰德类型的信息
 * @param {string} typeCode - 类型代码
 * @returns {Object} 类型信息
 */
export function getHollandTypeInfo(typeCode) {
  const types = getAllHollandTypes()
  return types.find(t => t.code === typeCode) || null
}
